import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M18.07 6.61A8.753 8.753 0 0 0 10 1.25h-.039a8.73 8.73 0 0 0-8.71 8.791 8.777 8.777 0 0 0 .937 3.904v2.97a.899.899 0 0 0 .898.898h2.97c1.212.61 2.549.93 3.905.937h.041a8.76 8.76 0 0 0 3.373-.67 8.681 8.681 0 0 0 2.79-1.86 8.728 8.728 0 0 0 2.586-6.182 8.716 8.716 0 0 0-.68-3.429Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M12.969 10a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm-7.813 0a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm3.907 0a.937.937 0 1 0 1.874 0 .937.937 0 0 0-1.874 0Z"
	})]
});
const ForwardRef = forwardRef(SvgIconmin);
export { ForwardRef as ReactComponent };
